"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeNode = exports.TreeActionLink = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var TreeContext_1 = require("./TreeContext");
var check_1 = require("../check");
var icon_1 = require("../icon");
var inject_value_1 = require("../_util/inject-value");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var merge_event_props_1 = require("../_util/merge-event-props");
var TreeNode_1 = require("./deprecated/TreeNode");
exports.TreeActionLink = react_1.default.forwardRef(function TreeActionLink(_a, ref) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("a", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-text--link", className) }, props), children));
});
exports.TreeActionLink.displayName = "TreeActionLink";
exports.TreeNode = forward_ref_with_statics_1.forwardRefWithStatics(function TreeNode(props, ref) {
    var _a = react_1.useContext(TreeContext_1.TreeContext), flatten = _a.flatten, activable = _a.activable, onActive = _a.onActive, expandedIds = _a.expandedIds, fullExpandable = _a.fullExpandable, fullActivable = _a.fullActivable, onExpand = _a.onExpand, onLoad = _a.onLoad, onLoadError = _a.onLoadError, switcherIcon = _a.switcherIcon, treeSelectable = _a.selectable;
    var expanded = react_1.useMemo(function () { return expandedIds.includes(props.id); }, [
        expandedIds,
        props.id,
    ]);
    if (!flatten) {
        return react_1.default.createElement(TreeNode_1.TreeNode, tslib_1.__assign({}, props, { ref: ref }));
    }
    return (react_1.default.createElement(TreeNodeInner, tslib_1.__assign({}, props, { ref: ref, activable: activable, onActive: onActive, fullExpandable: fullExpandable, fullActivable: fullActivable, expanded: expanded, onExpand: onExpand, onLoad: onLoad, onLoadError: onLoadError, switcherIcon: switcherIcon, treeSelectable: treeSelectable })));
}, {
    ActionLink: exports.TreeActionLink,
});
exports.TreeNode.displayName = "TreeNode";
var TreeNodeInner = react_1.memo(react_1.forwardRef(function TreeNodeInner(allProps, ref) {
    var id = allProps.id, _a = allProps.level, level = _a === void 0 ? 0 : _a, content = allProps.content, icon = allProps.icon, operation = allProps.operation, expandable = allProps.expandable, children = allProps.children, nodeSelectable = allProps.selectable, 
    // Context
    activable = allProps.activable, fullActivable = allProps.fullActivable, onActive = allProps.onActive, fullExpandable = allProps.fullExpandable, expanded = allProps.expanded, onExpand = allProps.onExpand, onLoad = allProps.onLoad, onLoadError = allProps.onLoadError, switcherIcon = allProps.switcherIcon, treeSelectable = allProps.treeSelectable, 
    // 外层使用
    disableSelect = allProps.disableSelect, pure = allProps.pure, className = allProps.className, style = allProps.style, 
    // 节点内无用
    height = allProps.height, pathKey = allProps.pathKey, 
    // 可透传属性
    props = tslib_1.__rest(allProps, ["id", "level", "content", "icon", "operation", "expandable", "children", "selectable", "activable", "fullActivable", "onActive", "fullExpandable", "expanded", "onExpand", "onLoad", "onLoadError", "switcherIcon", "treeSelectable", "disableSelect", "pure", "className", "style", "height", "pathKey"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var selectable = typeof nodeSelectable !== "undefined"
        ? nodeSelectable && treeSelectable
        : treeSelectable;
    var nodeIcon = inject_value_1.injectValue(icon)({ expanded: expanded });
    var switcherRef = react_1.useRef(null);
    function handleExpand(event) {
        if (switcherRef.current) {
            switcherRef.current.handleExpand(event);
        }
    }
    // activable 与 selectable 同时开启时 Checkbox 与内容结构分离
    var nodeContent = activable && selectable ? (react_1.default.createElement("div", { className: classPrefix + "-tree__label" },
        react_1.default.createElement(check_1.Check, { name: id, type: "checkbox" }),
        react_1.default.createElement("span", { className: classPrefix + "-tree__label-title", onClick: function (event) {
                if (!fullActivable) {
                    onActive(id, event, allProps);
                }
            } },
            nodeIcon,
            content,
            operation && (react_1.default.createElement("div", { className: classPrefix + "-tree__action", onClick: function (e) { return e.stopPropagation(); } }, operation))))) : (react_1.default.createElement("div", { className: classPrefix + "-tree__label", onClick: function (event) {
            if (!fullActivable && activable) {
                onActive(id, event, allProps);
            }
        } },
        selectable ? (react_1.default.createElement(check_1.Check, { name: id, type: "checkbox" },
            nodeIcon,
            content)) : (react_1.default.createElement(react_1.default.Fragment, null,
            nodeIcon,
            react_1.default.createElement("span", { className: classPrefix + "-tree__label-title" }, content))),
        operation && (react_1.default.createElement("div", { className: classPrefix + "-tree__action", onClick: function (e) { return e.stopPropagation(); } }, operation))));
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classPrefix + "-tree__node-content", style: fullActivable || fullExpandable ? { cursor: "pointer" } : undefined, 
        // eslint-disable-next-line dot-notation
        draggable: props["draggable"] }, merge_event_props_1.mergeEventProps(props, {
        onClick: function (event) {
            if (fullActivable && activable) {
                onActive(id, event, allProps);
            }
            if (fullExpandable && Boolean(expandable || children)) {
                handleExpand(event);
            }
        },
    })),
        new Array(level).fill(null).map(function (_, i) { return (react_1.default.createElement("span", { key: i, className: classPrefix + "-tree__space" })); }),
        react_1.default.createElement(TreeNodeSwitcher, { id: id, ref: switcherRef, icon: switcherIcon, enable: Boolean(expandable || children), expanded: expanded, onExpand: onExpand, onLoad: onLoad, onLoadError: onLoadError, classPrefix: classPrefix, allProps: allProps }),
        nodeContent));
}));
TreeNodeInner.displayName = "TreeNodeInner";
var TreeNodeSwitcher = react_1.forwardRef(function TreeNodeSwitcher(_a, ref) {
    var id = _a.id, enable = _a.enable, expanded = _a.expanded, onExpand = _a.onExpand, onLoad = _a.onLoad, _b = _a.onLoadError, onLoadError = _b === void 0 ? function () { return null; } : _b, _c = _a.icon, icon = _c === void 0 ? function (_a) {
        var expanded = _a.expanded;
        return (react_1.default.createElement(icon_1.Icon, { type: expanded ? "arrowdown" : "arrowright" }));
    } : _c, classPrefix = _a.classPrefix, allProps = _a.allProps;
    var _d = tslib_1.__read(react_1.useState(false), 2), loading = _d[0], setLoading = _d[1];
    var _e = tslib_1.__read(react_1.useState(false), 2), error = _e[0], setError = _e[1];
    var onExpandRef = react_1.useRef(onExpand);
    react_1.useEffect(function () {
        onExpandRef.current = onExpand;
    }, [onExpand]);
    var switcherIcon = inject_value_1.injectValue(icon)({ expanded: expanded, nodeId: id });
    react_1.useImperativeHandle(ref, function () { return ({ handleExpand: handleExpand }); });
    function handleExpand(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.stopPropagation();
                        if (expanded) {
                            onExpand(id, false, event, allProps);
                            return [2 /*return*/];
                        }
                        if (!onLoad) return [3 /*break*/, 6];
                        setError(false);
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, onLoad(id)];
                    case 2:
                        _a.sent();
                        // 外层 expand 状态变化导致 onExpand 更新
                        onExpandRef.current(id, true, event, allProps);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        setError(true);
                        onLoadError(id, err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        onExpand(id, true, event, allProps);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    if (loading) {
        return (react_1.default.createElement("a", { className: classPrefix + "-tree__switcher" },
            react_1.default.createElement(icon_1.Icon, { type: "loading" })));
    }
    var switcher = react_1.default.isValidElement(switcherIcon) ? (switcherIcon) : (react_1.default.createElement("div", null, switcherIcon));
    if (error) {
        switcher = react_1.default.createElement(icon_1.Icon, { type: "error" });
    }
    return enable ? (react_1.default.createElement("a", { className: classPrefix + "-tree__switcher", onClick: handleExpand }, switcher)) : (react_1.default.createElement("div", { className: classPrefix + "-tree__switcher" }));
});
TreeNodeSwitcher.displayName = "TreeNodeSwitcher";
//# sourceMappingURL=TreeNode.js.map